<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <form @submit.prevent="getRecords()">
          <div class="flex flex_gap">
            <div class="form-group">
              <label>Период отчета</label>
              <div class="input-group">
                <DateSelect
                  ref="dateFrom"
                  :selectedDate="preset.date.from"
                />
                <div class="input-group-prepend input-group-append">
                  <span class="input-group-text">по</span>
                </div>
                <DateSelect
                  ref="dateTo"
                  :selectedDate="preset.date.to"
                />
              </div>
            </div>
            <div class="form-group">
              <label>Выберите пользователя</label>
              <select v-model="selectedUser" class="form-control">
                <option value="0">Все пользователи</option>
                <option v-for="u in users" :value="u.id">{{ u.name }}</option>
              </select>
            </div>
          </div>
          <div class="text-right mt-1">
            <LoadingButton
              title="Показать"
              :color="$constants.SUCCESS_COLOR"
              type="submit"
              className="btn btn-outline-success"
              :loading="loading"
              :onClick="() => {}"
            />
          </div>
        </form>
      </div>
    </div>
    <div class="card" v-if="loading || records">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="!loading">
          <template v-if="!records || !Object.keys(records).length">
            <h5>Записей не найдено</h5>
          </template>
          <table class="table mt-1 table-sm table-hover" v-else>
            <thead>
            <tr>
              <th>Пользователь</th>
              <th>Диалог<br/>заявка</th>
              <th>статус</th>
              <th>заявок</th>
              <th>на сумму</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(oRecords,userId) in records">
              <tr>
                <td :rowspan="Object.keys(oRecords).length + 1">{{ users[userId].name }}</td>
                <td :rowspan="Object.keys(oRecords).length + 1">
                  <p>{{ dialogs?.[userId]?.total_dialogs }}</p>
                  <p>{{ getTotalOrders(userId) }}</p>
                </td>
              </tr>
              <tr v-for="status in statusSort" :key='`${userId}_${status}`' v-if="oRecords[status]">
                <td>{{ oRecords[status].status_label }}</td>
                <td>{{ oRecords[status].total_orders }}</td>
                <td>{{ oRecords[status].total_price }}</td>
              </tr>
            </template>
            </tbody>
          </table>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import DateSelect from "@/views/reports/components/DateSelect.vue";
import moment from 'moment';
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";

export default {
  components: {
    LoadingButton,
    DateSelect,
  },
  data() {
    return {
      loading: false,
      statusSort: [3, 2, 1, 9999, 0, -2, -3],
      users: {
        240: {id: 240, name: 'Ирина'},
        239: {id: 239, name: 'Евгения'},
      },
      records: null,
      dialogs: null,
      selectedUser: 0,
      preset: {
        date: {
          from: moment().subtract(1, 'month').format('DD.MM.YYYY'),
          to: moment().format('DD.MM.YYYY')
        }
      },
    }
  },
  methods: {
    getTotalOrders(userId) {
      return Object.values(this.records[userId] ?? {}).reduce((acc, s) => acc + s.total_orders, 0);
    },
    async getRecords(page = 1) {
      this.loading = true;
      const filter = {
        date: {
          from: this.$refs.dateFrom.date,
          to: this.$refs.dateTo.date
        },
        selectedUsers: +this.selectedUser ? [+this.selectedUser] : Object.values(this.users).map((u) => u.id)
      };
      const {data} = await api.post('/statistics/orders/chats', filter);
      if (data.success) {
        this.dialogs = data.dialogs.reduce((acc, d) => {
          acc[d.user_id] = d;
          return acc;
        }, {})
        this.records = data.records.reduce((acc, r) => {
          if (!acc[r.responsible_agent_id]) acc[r.responsible_agent_id] = {};
          acc[r.responsible_agent_id][r.status] = r;
          return acc;
        }, {});
      } else {
        toastr['warning'](data.message ?? 'ошибка сервера', 'Неуспешно');
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
.flex_gap {
  gap: 10px;
}
</style>
